<template>
  <div>
    <!-- <NuxtLoadingIndicator  color="#fff"/> -->
    <!-- User layout -->
    <!-- page header -->
    <MainHeader/>
    <!-- mobile info bar -->
    <ClientOnly>
      <InfoBar />
    </ClientOnly>
    <!-- loaders - temporarily -->
    <div class="main-section relative" v-if="isProductPageLoading || isStorePageLoading">
      <LoadingProduct v-if="isProductPageLoading"/>
      <LoadingStore v-else-if="isStorePageLoading"/>
    </div>

    <!-- page body -->
    <main v-show="!isProductPageLoading && !isStorePageLoading" class="main-section relative">
      <slot />
    </main>
    <!-- page footer -->
    <MainFooter/>
  </div>

</template>

<script>
import { MainHeader, MainFooter, LoadingProduct, LoadingStore, InfoBar } from "@/components";

import { mapState, mapActions } from 'pinia';
import { useGlobalStore } from '@/store/Modules/global';
import { APIREQUESTS, MAINROLES, isEmpty, SPECIFICROLES } from "@/helpers";
export default {
  name: "user-layout",
  data(){
    return {
      twakScript: "",
      hasGoogleAdsScriptLoaded: false,
      hasGotUserGeoLocation: false
    }
  },
  setup(){
    const nuxtApp = useNuxtApp();
    const isStorePageLoading = ref(false);
    const isProductPageLoading = ref(false);

    const productPageName = "product";
    const storePageName = "store";

    const handlePageLoadingState = ({pageName, isLoading, endLoading}) => {
      if(endLoading){
        isProductPageLoading.value = false;
        isStorePageLoading.value = false;
      }else{
          switch(pageName){
          case productPageName:
            isProductPageLoading.value = isLoading 
            break;
          case storePageName:
            isStorePageLoading.value = isLoading 
            break;
          default: () => {}
        }
      }
    }

    nuxtApp.hook("page:start", ({type}) => {
      handlePageLoadingState({pageName: type.name, isLoading: true});
    });

    nuxtApp.hook("page:finish", ({type}) => {
      handlePageLoadingState({pageName: type.name, isLoading: false});
    });
    nuxtApp.hook("page:loading:end", () => {
      handlePageLoadingState({endLoading: true});
    });
    return {
      isStorePageLoading,
      isProductPageLoading
    }
  },

  components: {
    MainHeader,
    MainFooter,
    LoadingProduct,
    LoadingStore,
    InfoBar
  },
  computed: {
    ...mapState(useGlobalStore, ['layout', 'hasTawkLoaded', 'localStorageCopy']),
    isGuest(){
      return this.localStorageCopy?.user?.role == SPECIFICROLES.guest
    },
  },
  methods:{
    ...mapActions(useGlobalStore, ['setLayout', 'updatehasTawkLoadingState', 'updateDisableChattingState', 'updateUserGeoLocation']),
    async getUserGeoLocation(){
      // gets the user GEO location and stores it in the global store (pinia)
      if(this.hasGotUserGeoLocation){
        return;
      }
      this.hasGotUserGeoLocation = true;
      try{
          //check geolocation permissions
          let permissionStatus = await navigator.permissions.query({ name: "geolocation" })
          if(permissionStatus.state=='granted'){
             let { lat, lng } = await this.getCurrentLocation();
             this.updateUserGeoLocation({ lat, lng });
          };
        }catch{}
    },
    async clickRankAi(){
      try{
          var clickRankAi = document.createElement("script");
          clickRankAi.src = "https://js.clickrank.ai/seo/46c6841d-0a9a-4a88-bcae-d4feb3e772fe/script?" + new Date().getTime();
          clickRankAi.async = true;
          document.head.appendChild(clickRankAi);
        }catch(err){
          console.error(err);
        }
    },
    getLayoutData() {
      this.makeRequest({
        url: `${APIREQUESTS.user.getLayout.url}`,
        method: APIREQUESTS.user.getLayout.method,
      })
      .then((res) => {
        if (!res?.status) {
          //not success
          isEmpty(res) ? this.notify({ type: 'error', msg: this.$t('general.unknown_error') }) : this.notify({ type: 'error', msg: res.message });
        } else {
          // success
          //inject response data in form data
          let layoutData = res?.data || null
          this.setLayout({ ...layoutData })
        }
      })
      .catch((err) => {
        //rejected
        isEmpty(err) ? this.notify({ type: 'error', msg: this.$t('general.unknown_error') }) : this.notify({ type: 'error', msg: err?.data?.message || "Error" });
      })
      .finally(() => {
      });
    },
    addGoogleAdsScriptInDom(){
      // Google Ads script
      if(this.hasGoogleAdsScriptLoaded){
        return;
      }
      const config = useRuntimeConfig();
      // create the script element
      const scriptElement = document.createElement("script");
      // set the attributes
      scriptElement.async = true;
      scriptElement.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${config.public.google_ads_key}`;
      scriptElement.setAttribute("strategy", "lazyOnload");
      scriptElement.crossOrigin = "anonymous";
      
      // append the script to the head of the document
      document.head.appendChild(scriptElement);
      // scriptElement.addEventListener('load', () => {
      //   useHead({
      //     script: [
      //       {
      //         children: `
      //           window.dataLayer = window.dataLayer || [];
      //           function gtag(){dataLayer.push(arguments);}
      //           gtag('js', new Date());
      //           gtag('config', '${config.public.google_ads_key}');
      //         `
      //       }
      //     ]
      //   });
      // });

      //above code- create element like this
      this.hasGoogleAdsScriptLoaded = true;
    },
    checkGuestForVerifyingEmail(){
      this.makeRequest({
        owner: MAINROLES.user,
        method: APIREQUESTS.user.getMyProfileInfo.method,
        url: APIREQUESTS.user.getMyProfileInfo.url,
      })
        .then((res) => {
          // failed
          if (!res?.status) {
            this.notify({
              type: 'error',
              msg: res.message,
            });
          } else {
            // succeeded
            const isEmailVerified = !!res?.data?.email_verified
            this.updateDisableChattingState(!isEmailVerified);
          }
        }).catch((err) => {
          console.error(err);
        })
    }
  },
  mounted(){
    if(process.client){
      this.getUserGeoLocation();
      this.getLayoutData()
      this.$nextTick(() => {
        this.addGoogleAdsScriptInDom()
      })
      
      // Mitigate AdSense overlay z-index: run after load and again later so we catch late-injected vignette
      // setTimeout(() => fixAdsenseZIndex(), 1500);
      // setTimeout(() => fixAdsenseZIndex(), 4000);

      // if the user is a Guest, check their email verification 
      if(this.isGuest){
        this.checkGuestForVerifyingEmail();
      }
    }
    // this.clickRankAi();
  },
  // beforeUnmount() {
  //   this.hideTwakChat();
  // },
}
</script>

<style>

</style>